import { render, staticRenderFns } from "./GenderCountTable.vue?vue&type=template&id=1a8466ca&"
import script from "./GenderCountTable.vue?vue&type=script&lang=ts&"
export * from "./GenderCountTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports